import {
  Button,
  Flex,
  Icon,
  Img,
  ModalBody,
  ModalHeader,
  Text,
} from "@chakra-ui/react";
import { ModalFooter } from "react-bootstrap";
import logoMonedd from "../../../../assets/images/logo.png";
import moment from "moment";
import { FaCircle } from "react-icons/fa";
import {
  CEPFormater,
  CNPJFormater,
  CPFFormater,
  PhoneFormater,
} from "../../../../defaultFunctions/formaters";
import { forwardRef } from "react";

const ModalContentToPrint = forwardRef(({ item }: any, ref: any) => {
  return (
    <div ref={ref}>
      {item && (
        <ModalBody
          display={"flex"}
          flexDir="column"
          justifyContent={"space-evenly"}
          alignItems="center"
        >
          <Flex
            w={"350px"}
            alignItems={"flex-start"}
            flexDirection="column"
            justifyContent={"space-evenly"}
            px={5}
            shadow={"md"}
            fontSize={"0.8rem"}
            bgColor="#FBFBE2"
          >
            <Img src={logoMonedd} />
            <Text fontWeight="bold" w={"100%"} textAlign="center">
              VIA CLIENTE
            </Text>
            <Text textTransform="uppercase" w={"100%"} textAlign="center">
              {item.bandeiraCartao} - {item.nomeModoPgto} -{" "}
              {(item.parcelas === 1 && "À Vista") ||
                (item.parcelas != 1 && `${item.parcelas} vezes`)}
            </Text>
            <Text>-----------------------------------------</Text>
            <Text
              fontWeight="bold"
              fontSize={"1.2rem"}
              textTransform="uppercase"
              my={0.5}
            >
              {item.isCnpj === true
                ? item?.razaoSocial
                : `${item?.nome} ${item.sobrenome}`}
            </Text>
            <Text my={0.5} mb={4}>
              CNPJ:{" "}
              {item.cnpj.length > 11
                ? CNPJFormater(item.cnpj)
                : CPFFormater(item.cnpj)}
            </Text>
            <Text fontSize={"0.6rem"} my={0.5}>
              Id da transação: {item.idTransacao}
            </Text>

            <Text fontSize={"0.6rem"} my={0.5}>
              Serial da POS: {item.serialPOS}
            </Text>

            <Text>-----------------------------------------</Text>
            <Text fontWeight={"bold"}>{item.clienteNome}</Text>
            <Text fontWeight={"bold"}>
              {item.cartaoInicio} **** **** {item.cartaoFim}
            </Text>

            <Text fontSize={"0.6rem"}>
              Status:
              {(item.status === "succeeded" && (
                <>
                  <Icon ml={2} mr={2} as={FaCircle} color={"green"} />
                  Sucesso
                </>
              )) ||
                (item.status === "pending" && (
                  <>
                    <Icon ml={2} mr={2} as={FaCircle} color={"yellow"} />
                    Pendente
                  </>
                )) ||
                (item.status === "failed" && (
                  <>
                    <Icon ml={2} mr={2} as={FaCircle} color={"orange"} />
                    Falhou
                  </>
                )) ||
                (item.status === "reversed" && (
                  <>
                    <Icon ml={2} mr={2} as={FaCircle} color={"pink"} />
                    Revertido
                  </>
                )) ||
                (item.status === "new" && (
                  <>
                    <Icon ml={2} mr={2} as={FaCircle} color={"gray"} />
                    Nova
                  </>
                )) ||
                (item.status === "chargeback" && (
                  <>
                    <Icon ml={2} mr={2} as={FaCircle} color={"purple"} />
                    ChargeBack{" "}
                  </>
                )) ||
                (item.status === "canceled" && (
                  <>
                    <Icon ml={2} mr={2} as={FaCircle} color={"red"} />
                    Cancelado{" "}
                  </>
                ))}
            </Text>
            <Text fontSize={"0.6rem"}>
              N° da Transação: {item?.numeroTransacao}
            </Text>

            <Text fontSize={"0.6rem"}>
              Custo da Transação:{" "}
              {item?.taxaCliente.toLocaleString("pt-BR", {
                style: "currency",
                currency: "BRL",
              })}
            </Text>

            <Flex w={"100%"} h={"20px"}></Flex>
            <Flex
              w={"100%"}
              justifyContent={"flex-start"}
              alignItems={"center"}
              mb={"50px"}
            >
              <Text fontWeight={"bold"} marginRight={"25%"}>
                {moment(item.dataCriacao).format("DD/MM/YYYY")}
                <br />
                {moment(item.dataCriacao).format("HH:mm")}
              </Text>
              <Text fontWeight={"bold"} fontSize={"1.2rem"}>
                <span style={{ fontSize: "0.6rem" }}>Valor:</span>
                <br />
                {item?.valor.toLocaleString("pt-BR", {
                  style: "currency",
                  currency: "BRL",
                })}
              </Text>
            </Flex>
          </Flex>
        </ModalBody>
      )}
    </div>
  );
});
export default ModalContentToPrint;
